<template lang="pug">

  .lesson-block.main-block
    Preview(
      v-if="!isEditLocal"
      :content="contentLocal"
    )
    EditState(
      v-else-if="isEditLocal"
      :content="contentLocal"
      :isLoading="isLoading"
      @updateContent="updateContent"
      @saveBlockWithGet="saveBlockWithGet"
    )

    ControlsArrow.lesson__controls(
      :firstBlock="isFirstBlock"
      :lastBlock="isLastBlock"
      v-if="$permissionsUpdate"
      @moveUp="moveUp"
      @moveDown="moveDown"
    )

    OptionsList.course-lesson__options(
      v-if="optionsFields.length"
      :optionsFields="optionsFields"
    )

</template>

<script>
import _ from 'lodash';
import Preview from './Preview';
import EditState from './EditState';
import blockPermissionMixin from '@/views/Courses/Lesson/components/block.permission.mixin';

export default {
  components: { Preview, EditState },
  mixins: [blockPermissionMixin],
  props: ['content', 'isFirstBlock', 'isLastBlock', 'isLoading', 'permissions'],
  data() {
    return {
      isEditLocal: false,
      contentLocal: {}
    };
  },
  computed: {
    optionsFields() {
      const arr = [];
      if (this.$permissionsUpdate) {
        arr.push({
          text: 'Редактировать',
          func: this.openBlockEdit,
          icon: 'edit'
        });
      }
      if (this.$permissionsDelete) {
        arr.push({
          text: 'Удалить',
          func: this.deleteBlock,
          icon: 'delete',
          iconWidth: '10px',
          confirm: true,
          confirmTitle: 'Вы уверены, что хотите удалить этот блок?',
          confirmDescription: 'Блок будет удален навсегда',
          confirmApplyText: 'Удалить',
          confirmCancelText: 'Отменить',
          red: true
        });
      }

      return arr;
    }
  },
  watch: {
    isEditLocal(val) {
      if (val) {
        this.optionsFields.push({
          text: 'Отменить',
          func: this.cancel
        });
      } else {
        this.optionsFields.splice(this.optionsFields.length - 1, 1);
      }
    },
    content() {
      this.setData();
    },
    isLoading(curr, prev) {
      if (prev === true && curr === false) {
        this.isEditLocal = false;
      }
    }
  },
  mounted() {
    this.setData();

    if (this.contentLocal.forceEdit) {
      this.isEditLocal = true;
      delete this.contentLocal.forceEdit;
    }
  },
  methods: {
    setData() {
      this.contentLocal = _.cloneDeep(this.content);
    },
    openBlockEdit() {
      this.isEditLocal = true;
    },
    deleteBlock() {
      this.$emit('deleteBlock');
    },
    updateContent(content) {
      this.contentLocal = _.cloneDeep(content);
    },
    saveBlockWithGet() {
      this.$emit('saveBlockWithGet', this.contentLocal);
    },
    cancel() {
      this.isEditLocal = false;
    },
    moveUp() {
      this.$emit('moveUp');
    },
    moveDown() {
      this.$emit('moveDown');
    },
    showAdminMessage() {
      this.$store.dispatch(
        'ajax/addMessage',
        { message: 'В режиме администратора не работает', type: 'success' },
        { root: true }
      );
    }
  }
};
</script>
